export const StageDotIcon = ({ color }: { color: string }) => (
  <div style={{ background: color }} className="w-3 h-3 rounded-full shrink-0" />
);
